import { SurveyViewAnswer } from "@/redux/survey-views/types";
import { SurveyViewFormAnswer } from "@/features/survey-views/form/types";

export const toFormAnswers = (
  answers: SurveyViewAnswer[],
): SurveyViewFormAnswer[] =>
  answers.map((answer) => ({
    answer: answer.answer,
    question: answer.question,
    attachedBlocks: answer.attachedBlocks.map((block) => ({
      id: block.id,
      sharingRights: block.sharingRights,
    })),
  }));
